import React from 'react'
import classNames from 'classnames'
import styles from './index.less'

//  因为  art-empty-wrapper 默认值css  pointer-events: none;
//  导致  empty组件里面的button 不能点击
//  所以  css覆盖为 pointer-events: auto;

// 因为 empty组件 不居中了
// 然后 发现art-table-cell position relative导致的，但是有可能表格确实需要这个属性
// 所以 art-table-cell.first.last { position: unset !important;} 这样的话 .first.last 代表是空的

const AntEmptyContent = ({ emptyText = '', className }) => (
    <div className={classNames(styles.emptyWrap, className)}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="41"
            className="ant-empty-img-simple"
            viewBox="0 0 64 41"
        >
            <g fill="none" fillRule="evenodd" transform="translate(0 1)">
                <ellipse cx="32" cy="33" className="ant-empty-img-simple-ellipse" rx="32" ry="7" />
                <g fillRule="nonzero" className="ant-empty-img-simple-g">
                    <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z" />
                    <path
                        d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                        className="ant-empty-img-simple-path"
                    />
                </g>
            </g>
        </svg>
        <div className="empty-tips gylColorGrayN6" style={{ marginTop: 8, fontSize: 14 }}>
            {emptyText ? emptyText : '暂无数据'}
        </div>
    </div>
)

export default React.memo(AntEmptyContent)
